import {SxProps, Theme} from '@mui/material';
import {StatusColors} from 'src/components/common/ColoredStatus/ColoredStatus.hook';
import theme from 'src/theme';

/**
 * The segments, fused into one pill.
 *
 * One object, because one charger is one thing to the person scanning the list; the sockets inside it
 * are its parts. Rounded once on the outside and clipped, so the segments share the pill's corners
 * instead of each carrying their own.
 */
export const fusedSx: SxProps<Theme> = {
    display: 'inline-flex',
    maxWidth: '100%',
    borderRadius: theme.spacing(4 / 8),
    overflow: 'hidden',
    verticalAlign: 'middle',
};

/**
 * One socket.
 *
 * The hairline is white rather than a grey: it is the gap between two coloured grounds, and a grey
 * line between a green and a red reads as a third colour.
 */
export const segmentSx = (colors: StatusColors, fontSize: number): SxProps<Theme> => ({
    background: colors.background,
    color: colors.color,
    padding: theme.spacing(3 / 8, 1),
    fontSize,
    fontWeight: 700,
    letterSpacing: '0.03em',
    lineHeight: 1.45,
    whiteSpace: 'nowrap',
    '&:not(:first-of-type)': {
        borderLeft: `1px solid ${theme.palette.common.white}`,
    },
    // The same drawn shape the single pill takes below a desktop, minus the corner, which the pill
    // around them owns.
    [theme.breakpoints.down('md')]: {
        padding: '5px 9px',
        fontSize: '11px',
        fontWeight: 700,
    },
});
